export default __webpack_public_path__ + "static/media/white-delete-icon.74eb4126.svg";